<template>
  <div class="row">
    <div class="col-12">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fa-fw"></i>
          </span>
        </div>
        <select
          class="custom-select"
          :id="`${id}_input`"
          :name="name + '[]'"
          multiple
          :style="height"
          ref="select"
          :placeholder="placeholder"
          :required="required"
          :readonly="readonly"
          :disabled="disabled"
        >
        <option :key="x.id" v-for="x in listData" v-bind:value="x.id">{{x.name}}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
	  "title": String,
	  "name": String,
	  "id": String,
	  "data-type": String,
	  "icon": String,
	  "required": {
      type: Boolean,
		default: true
	},
  "placeholder": String,
  "readonly": {
    type: Boolean,
    default: true
  },
  
  "disabled": {
    type: Boolean,
    default: true
  },
  height: {
    type: String,
    default: "height: 184px"
  },

  },
  data: function(){
    return {
      listData: [],
      actualVal: this.value,
      customerId: ''
    }
  },

  watch : {
    customerId: function () {
      var self = this;
      axios.get(`/customer_base/getResponsibles?id=${self.customerId}`)
			    .then(function(response) {
            console.log(response)
            self.listData = response.data;
          })
          .catch(function(error) {
            console.error(error);
          })
    }
  },

  mounted() {
    this.popData()
  },
  methods: {
    popData: function(){
      var self = this;

      switch(this.dataType) {

        case 'usersList':
          axios.get('release/userList')
          .then(function(response){
            self.listData = response.data;
            })
          .catch(function(error){
            console.error(error);
          })
		      break;

        case 'listQueue':
			    axios.get('user/listQueue')
          .then(function(response) {
        	  self.listData = response.data;
		        })
		      .catch(function(error) {
			      console.error(error);
          })
		      break;

		    case 'listQueueChat':
			    axios.get('user/listQueueChat')
			    .then(function(response) {
            self.listData = response.data;
          })
          .catch(function(error) {
            console.error(error);
          })
		      break;

        case 'department':
			    axios.get('/departments')
			    .then(function(response) {
            self.listData = response.data;
          })
          .catch(function(error) {
            console.error(error);
          })
		      break;

        case 'departmentTypes':
			    axios.get('/departmentTypes')
			    .then(function(response) {
            self.listData = response.data;
          })
          .catch(function(error) {
            console.error(error);
          })
		      break;
        
		    case 'responsibleList':
			    axios.get(`/customer_base/getResponsibles?id=${this.customerId}`)
			    .then(function(response) {
            self.listData = response.data;
            console.log("listData Multiselect", self.listData)
          })
          .catch(function(error) {
            console.error(error);
          })
		      break

      }
    },
  }
};
</script>